import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import { HiOutlineDocumentText } from 'react-icons/hi2';
import { contact } from '../content/data';

const Footer = () => {
  // Note: kept as a functional component; removed unused copy-to-clipboard state/handlers.

  return (
    <footer className="py-16 bg-page-light border-t border-card-border">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-h1 gradient-text mb-3">Let's Connect</h2>
          <p className="text-muted text-body-lg max-w-lg mx-auto">
            Open to opportunities in software engineering and ML engineering. 
            Feel free to reach out!
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-6 mb-10"
        >
          <a
            href={contact.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-gray-300 hover:text-indigo-400 transition-colors"
            aria-label="LinkedIn"
            title="LinkedIn"
          >
            <FaLinkedin className="text-2xl" aria-hidden="true" focusable="false" />
            <span className="sr-only">LinkedIn</span>
          </a>
          <a
            href={contact.github}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-gray-300 hover:text-indigo-400 transition-colors"
            aria-label="GitHub"
            title="GitHub"
          >
            <FaGithub className="text-2xl" aria-hidden="true" focusable="false" />
            <span className="sr-only">GitHub</span>
          </a>
          <a
            href={contact.resume}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-gray-300 hover:text-indigo-400 transition-colors"
            aria-label="Resume"
            title="Resume"
          >
            <HiOutlineDocumentText className="text-2xl" aria-hidden="true" focusable="false" />
            <span className="sr-only">Resume</span>
          </a>
          <a
            href={`mailto:${contact.email}`}
            className="p-2 text-gray-300 hover:text-indigo-400 transition-colors"
            aria-label="Email"
            title="Email"
          >
            <FaEnvelope className="text-2xl" aria-hidden="true" focusable="false" />
            <span className="sr-only">Let's Talk</span>
          </a>
        </motion.div>

        <div className="border-t border-card-border pt-8 text-center text-muted text-caption">
          <p>&copy; {new Date().getFullYear()} Christopher Tengey. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
